const arrayUtils = {
    groupBy: (items, key) => {
        return items.reduce(function (result, item) {
            const idValue = key.split('.').reduce((acc, part) => acc && acc[part], item);
            (result[idValue] = result[idValue] || []).push(item);
            return result;
        }, {});
    },
    standardGroupBy: (xs, key) => {
        return xs.reduce((rv, x) => {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    },
    buildInputsValueMap: (rows) => {
        let inputsMap = [];
        rows.forEach((htmlInput, idx) => {
            let inputs = htmlInput.getElementsByTagName('input');
            let selects = htmlInput.getElementsByTagName('select');
            let currentInput = {};
            Object.values(inputs).forEach((input) => {
                if (input.type === 'checkbox') {
                    currentInput[input.name] = input.checked;
                }
                if (input.type === 'text') {
                    currentInput[input.name] = input.value;
                }
            });
            Object.values(selects).forEach((select) => {
                currentInput[select.name] = select.value;
            });
            inputsMap.push(currentInput);
        });
        return inputsMap;
    },
};
export default arrayUtils;
